module.exports = "/Public/build/7e365d3ed0f3ea5f7e3f1548810d9dfd.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/logo.svg
// module id = 83
// module chunks = 0 1